import { UserType } from '../interfaces/userType.enum';

/** SalesInvoiceController POST: @PreAuthorize("hasAnyRole('Accountant','InstitutionAdmin')"). */
export const SALES_INVOICE_CREATE_ROLES: UserType[] = [UserType.Accountant, UserType.InstitutionAdmin];

/** QuotationController POST: @PreAuthorize("hasAnyRole('SalesRep','Accountant','InstitutionAdmin')"). */
export const QUOTATION_CREATE_ROLES: UserType[] = [UserType.SalesRep, UserType.Accountant, UserType.InstitutionAdmin];
